import type { FaireProductEntity } from "../../entity_types/product";

export const p_frkjed326u: FaireProductEntity = {
  token: "p_frkjed326u",
  type: "product",
  name: "Slim Fit Paneled Zip-Up Activewear Jacket",
  brandToken: "b_elccldtdr7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d122aa934bcc546956ec8b7a07a894330407285f1022802be82bf88a26c00eb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03ffecbbfd35e872a9642ceb16b3a2c26da43e4564a92639ef26a82b8d27c574.jpeg",
    "https://cdn.faire.com/fastly/814c2d0e2cd52ab5d1688dc48b8c1f16b16f528c1ff6a70f89a953e365588dfe.jpeg",
    "https://cdn.faire.com/fastly/575022721d6bde6f8be8f3c1762644bc8c30ea49d1c15fea23c71551c396ef93.jpeg",
    "https://cdn.faire.com/fastly/827087a87f3c54466fe7bce8d3c470cc1fe89ad9767714935b7b65ffb2b71467.jpeg",
    "https://cdn.faire.com/fastly/ea615b6a0184f5691cf928209528c6c4a61640e0f29dab05d1fe7f7d2d4aa09d.jpeg",
    "https://cdn.faire.com/fastly/607735de96bacb1ce4df053acae04261ce00ca83c9e6d3bb585f2f563f9ed01b.jpeg",
    "https://cdn.faire.com/fastly/4792eb5e9ea772f8985ebaa4dbbd7528577c7f4e4f0cfca23c1fcb1d601658fd.jpeg",
    "https://cdn.faire.com/fastly/664010cf1cd05d8c49c037c213b18ad36e69318769cce670b7994fe371e0308b.jpeg",
    "https://cdn.faire.com/fastly/a27d95236dc78781437693aa56f480f5c6857a5dc832da4726a1dd78c35e18b7.jpeg",
    "https://cdn.faire.com/fastly/9fb14cda68ed6165969a8e2d7a48e944c579e67c1b5d89c293297f5d74912700.jpeg",
    "https://cdn.faire.com/fastly/5afc423f509aaeea9ffceb101646141168a15b221f3c4e062684397273912f92.jpeg",
    "https://cdn.faire.com/fastly/0512e1badd7b83742d7cfb116fe201ba0808e3228f5fb4a4c066c47a84d0f9fc.jpeg",
  ],
  priceDollars: 29.09,
  description:
    "This sleek activewear jacket features a slim fit design with strategic paneling for enhanced mobility. The zip-up collar and thumb holes provide extra coverage and comfort during workouts or casual wear.\n  \n  Features:\n  • 82% Polyester, 18% Spandex\n  • S-L: 2-2-2\n  • Slim fit with paneled construction\n  • Zip-up collar and thumb holes\n  • Thin, lightweight fabric\n  • Made in China",
  tags: [],
  msrpDollars: 58.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:38.688Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
